
    const new_defaults = {
      cartModal: '.js-ajax-cart-modal', // classname
      cartModalContent: '.js-ajax-cart-modal-content', // classname
      cartModalClose: '.js-ajax-cart-modal-close', // classname
      cartDrawer: '.js-ajax-cart-drawer', // classname
      cartDrawerContent: '.js-ajax-cart-drawer-content', // classname
      cartDrawerClose: '.js-ajax-cart-drawer-close', // classname
      cartDrawerTrigger: '.js-ajax-cart-drawer-trigger', // classname
      cartOverlay: '.js-ajax-cart-overlay', // classname
      cartCounter: '.js-ajax-cart-counter', // classname
      addToCart: '.action_button.add_to_cart', // classname
      removeFromCart: '.js-ajax-remove-from-cart', //classname
      removeFromCartNoDot: 'js-ajax-remove-from-cart', //classname,
      checkoutButton: '.js-ajax-checkout-button',
    };
    
    const cartModal = document.querySelector(new_defaults.cartModal);
    const cartModalContent = document.querySelector(new_defaults.cartModalContent);
    const cartModalClose = document.querySelector(new_defaults.cartModalClose);
    const cartDrawer = document.querySelector(new_defaults.cartDrawer);
    const cartDrawerContent = document.querySelector(new_defaults.cartDrawerContent);
    const cartDrawerClose = document.querySelector(new_defaults.cartDrawerClose);
    const cartDrawerTrigger = document.querySelector(new_defaults.cartDrawerTrigger);
    const cartOverlay = document.querySelector(new_defaults.cartOverlay);
    const cartCounter = document.querySelector(new_defaults.cartCounter);
    const addToCart = document.querySelectorAll(new_defaults.addToCart);
    let removeFromCart = document.querySelectorAll(new_defaults.removeFromCart);
    const checkoutButton = document.querySelector(new_defaults.checkoutButton);
    const htmlSelector = document.documentElement;
      
  var $ = jQuery;
    $(document).on('click', '.button-card-addtocart' ,function(event) {

      event.preventDefault();
      const formID = $(this).closest('form');
      addProductToCart(formID);
      return false;

    });



function addProductToCart(formID) {
    $.ajax({
      type: "post",
      url: "/cart/add.js",
      data: formID.serialize(),
      dataType: "json",
      success: function(data){
        addToCartOk();
      },
      error: function(err){
        addToCartFail(formID);
      }
    })
}
window.fetchCart();
function fetchCart() {
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {
            onCartUpdate(cart);

            
            if (cart.item_count === 0) {
              $('.empty_text').show();
              $('.psh-Cart_Footer,.psh-Topbar_Subtitle').hide();
              
              $('.psh-Topbar_Titles span,.cart-count-header').text('('+cart.item_count+')');
              $('.js-ajax-cart-drawer-content').append($('.ctm_empty_cpy_txt').clone());
              $('.js-ajax-cart-drawer-content .ctm_empty_cpy_txt').removeClass('hide');
              $('.drw-Drawer').addClass('js-empty_drawer');
              $('.site-header-cart .site-header-cart--count').attr('data-header-cart-count',cart.item_count).removeClass('visible');
            } else {
              $('.empty_text').hide();
                renderCart(cart);
              $('.psh-Topbar_Titles span,.cart-count-header').text('('+cart.item_count+')');
               $('.js-ajax-cart-drawer-content .ctm_empty_cpy_txt').remove();
              $(checkoutButton).removeClass('is-hidden');
              $('.psh-Cart_Footer,.psh-Topbar_Subtitle').show();
              $('.drw-Drawer').removeClass('js-empty_drawer');
              $('.site-header-cart .site-header-cart--count').attr('data-header-cart-count',cart.item_count).addClass('visible');
            }

          var total = cart.total_price, limit = parseInt($('.psh-Footer_Freeshipping_msg').data('limit')), msg = $('.psh-Footer_Freeshipping_msg').data('limit-text'), reached_msg = $('.psh-Footer_Freeshipping_msg').data('reached-text');
          var final_price = limit - total;
          if( total < limit){
           msg = msg.replace('[amount]',window.Shopify.formatMoney(final_price, window.money_format));
           $('.psh-Footer_Freeshipping_msg p').text(msg);
          }else{
            var text = setInterval(function(e){
             $('.psh-Footer_Freeshipping_msg p').text(reached_msg);  
            },10)
            setTimeout(function(e){
             clearInterval(text); 
            },500)
          }
        },
    });
}

function changeItem(line, callback) {
    const quantity = 0;
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + quantity + '&line=' + line,
        dataType: 'json',
        success: function(cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            } else {
                onCartUpdate(cart);
                fetchCart();
                removeProductFromCart();
            }
        },
    });
}

function onCartUpdate(cart) {
  if(cart.item_count != 0){
    $('.cart-count-bubble').show();
    $('.cart-count-bubble').text(cart.item_count);
  }else{
    $('.cart-count-bubble').hide();
    $('.cart-count-bubble').text(cart.item_count);
  }
  setTimeout(function(){
    $('.psh-Footer_Subtotal span').html(window.Shopify.formatMoney(cart.items_subtotal_price, window.money_format));
  },50)
}
 
function addToCartOk(product) {
//     cartModalContent.innerHTML = product.title + ' was added to the cart!';
//     cartCounter.innerHTML = Number(cartCounter.innerHTML) + 1;
//     openAddModal();
//     openCartOverlay();
  fetchCart();
  $(".drw-Drawers, body").addClass("drw-Drawers-active");
  $(".drw-Drawer").addClass("drw-Drawer-active");
  $('.pro-form-main').show();
}

function removeProductFromCart() {
    $(cartCounter).html(Number($(cartCounter).html()) - 1);
}

function addToCartFail(form_id) {
  
//     cartModalContent.innerHTML = 'The product you are trying to add is out of stock.';
   $('.ctm_product_added_err').removeClass('ctm_product_added_err');
	$('#'+form_id).append('<p class="ctm_product_added_err">The product you are trying to add is out of stock.</p>');
    setTimeout(function(e){
	  $('.ctm_product_added_err').remove();
    },4000)
//     openAddModal();
//     openCartOverlay();
}

function renderCart(cart) {

    console.log(cart);

    clearCartDrawer();

  
    cart.items.forEach(function(item, index) {

      var img = item.image;
      var origin = "//cdn.shopify.com/";
      var small_img_extension = item.image;
      if(img != null && img != undefined){
        small_img_extension = item.image.split(origin)[1];
        if(small_img_extension.indexOf('webp') > -1){
          var small_img_url = item.image;
        }else{
          var small_img_url = origin + small_img_extension.split('.')[0] + '_100x.' + small_img_extension.split('.')[1];
        }
      }
     
      const productTitle = ' <h5 class="psh-Item_Title "><a class="psh-Item_TitleLink" href="'+ item.url +'">' + item.title + '</a></h5>';
      const productImage = '<a class="psh-Item_ImageContainer" href="'+ item.url +'"><img class="psh-Item_Image" src="' + small_img_url + '" ></a>';
      var prod_variant ='';
      var properties_html = '';
      var propeties = item.properties;
      if(propeties != null && propeties != ''){
        const properties_keys = Object.keys(propeties);
        properties_keys.forEach(function(key) {
          var property_html = `<div class="item-property">${key}: ${propeties[key]}</div>`;
          properties_html += property_html;
        }); 
      }
      if(item.options_with_values[0].value != 'Default Title'){
       prod_variant = '<div class="ctm_selected_variant">'+item.options_with_values[0].name+': <span>'+item.options_with_values[0].value+'</span></div>'
       }
      var selling_html='';
      if(item.selling_plan_allocation != undefined){
       selling_html += '<div class="selling_plan"><span>'+item.selling_plan_allocation.selling_plan.name+'</span></div>';
      }

      const productPrice = ' <p class="psh-Item_Price fz-1320"><span class="money">' + window.Shopify.formatMoney(item.price, window.money_format) + '</span></p>';
      var productQuantity = selling_html+'<div class="psh-Item_Controls flex align-item-center space-between"  data-line="' + Number(index + 1) + '">'+productPrice
                            +'<div class="qty_btn_wrapper"><div class="psh-Quantity">';
      productQuantity +=    '<div class="product-quantity-box"><button class="psh-Quantity_Button psh-Quantity_Decrease product-minus js-change-quantity"  data-func="minus"><svg width="10" height="4" viewBox="0 0 10 4" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0.837461 0.874V3.656H9.15746V0.874H0.837461Z" fill="#F4F3FF"/> </svg></button><input type="text" min="0" class="psh-Quantity_Value fz-1417 quantity" name="updates[]" id="updates_'+item.id+'" value="'+item.quantity+'" data-cart-quantity-input="mini-cart"><button class="psh-Quantity_Button psh-Quantity_Increase product-plus js-change-quantity" data-func="plus"><svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M11.09 3.874H7.37201V0.156H4.59001V3.874H0.898008V6.656H4.59001V10.348H7.37201V6.656H11.09V3.874Z" fill="#F4F3FF"/> </svg></button></div></div>'
      productQuantity += '<div class="ajax-cart-item__remove ' + new_defaults.removeFromCartNoDot + '"><span class="remove_icon">Quitar</span></div></div>' +'</div>';
      var html = ' <li class="psh-Body_Item" data-cart-form="mini-cart" data-cart-item data-line-id="' + Number(index + 1) + '" data-variant-id="'+item.id+'"><div class="ajax-cart-item__single psh-Item flex">'
      const concatProductInfo = html + productImage + '<div class="psh-Item_Content"><div class="content flex space-between">' +  productTitle 
//       + prod_variant 
      +'</div>' 
      + properties_html + productQuantity + '</div></div>' ;
      cartDrawerContent.innerHTML = cartDrawerContent.innerHTML + concatProductInfo;
      cartDrawerContent.innerHTML = cartDrawerContent.innerHTML + '</div></li>'

    });
  
    removeFromCart = document.querySelectorAll(new_defaults.removeFromCart);
//     $('.psh-Footer_Subtotal span').text(Shopify.formatMoney(cart.items_subtotal_price, Shopify.money_format));
    for (let i = 0; i < removeFromCart.length; i++) {
      removeFromCart[i].addEventListener('click', function() {
        const line = $(this).closest('.psh-Body_Item').attr('data-line-id'); 
        changeItem(line);
      });
    }
    
  

    // document.querySelectorAll('.js-ajax-remove-from-cart')
    //     .forEach((element) => {
    //         element.addEventListener('click', function() {
    //             const lineID = this.parentNode.getAttribute('data-line');
    //             console.log('aa');
    //         });
    //     });

   
 
}

$(document).on('click','.psh-Footer_btn.button',function(e) {
  $(".drw-Drawers, body").removeClass("drw-Drawers-active");
  $(".drw-Drawer").removeClass("drw-Drawer-active");
})

function openCartDrawer() {
    cartDrawer.classList.add('is-open');
}

function closeCartDrawer() {
    cartDrawer.classList.remove('is-open');
}

function clearCartDrawer() {
    cartDrawerContent.innerHTML = '';
}


document.addEventListener('DOMContentLoaded', function() {
    fetchCart();
});


$('body').on('change', '[data-cart-quantity-input]', function() {
  var cartItem = {
    lineID: $(this).parents('[data-cart-item]').data('line-id'),
    variantID: $(this).parents('[data-cart-item]').data('variant-id'),
    quantity: $(this).val(),
    parentCartForm: $(this).parents('[data-cart-form]'),
    totalDiscount: $(this).parents('[data-cart-form]').data('total-discount'),
    $element : $(this).parents('[data-cart-item]')
  }
  // Disable button after click to prevent multiple clicks
  $(this).parents('.product-quantity-box').find('.js-change-quantity').addClass('is-disabled');
  updateCartItemQuantity(cartItem);
});

$('body').on('click', '.js-change-quantity', function() {
  var $this = $(this),
      $input = $(this).siblings('input'),
      val = parseInt($input.val()),
      valMax = 100000000000000000000000000000,
      valMin = $input.attr('min') || 0;

  if ($input.attr('max') != null){
    valMax = $input.attr('max');
  }

  if(isNaN(val) || val < valMin) {
    $input.val(valMin);
    return false;
  } else if (val > valMax) {
    $input.val(valMax);
    return false;
  }

  if($this.data('func') == 'plus') {
    if(val < valMax) $input.val(val + 1);
  } else {
    if(val > valMin) $input.val(val - 1);
    if($this.parents(".cart_item").length) {
      if (val - 1 == 0) {
        $this.closest('.cart_item').addClass('animated fadeOutUp')
      }
    }
  }
  $input.trigger('change');

});

function updateCartItemQuantity(cartItem) {
  $.ajax({
    url: '/cart/change.js',
    dataType: 'json',
    cache: false,
    type: 'post',
    data: {
      quantity: cartItem.quantity,
      line: cartItem.lineID
    },
    success: function (data) {
      console.log(data)
      console.log(cartItem.quantity,cartItem.lineID);
      $('.js-ajax-cart-counter').text(data.item_count);

      var cartItemsArray = data.items;
      var lineIDIndex = cartItem.lineID - 1;
      var totalCartItems = cartItem.parentCartForm.find('[data-variant-id]').length;
      var $quantityInputs = cartItem.parentCartForm.find('[data-variant-id="' + cartItem.variantID + '"] input');
      var initialQuantityTotal = 0;
      var apiQuantityTotal = 0;
      var apiLineItemQuantity = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;

      // Check if item has a "Buy X get Y" deal
      if ($quantityInputs.length > 1) {
        // Multiple inputs

        // Get all the quantities of same variants in the cart (including BOGO) in HTML
        $.each($quantityInputs, function (i, input) {
          initialQuantityTotal += parseInt($(input).val());
        });

        // Get quantities from cart object returned from API
        cartItemsArray.forEach(function (item) {
          if (item.variant_id === cartItem.variantID) {
            apiQuantityTotal += item.quantity;
          }
        })
      } else {
        // Single input
        initialQuantityTotal = parseInt($quantityInputs.val());
        apiQuantityTotal = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;
      }

      //Checks to see if there is enough inventory to update to an increased amount
      if (initialQuantityTotal > 0 && initialQuantityTotal > apiQuantityTotal) {            

        //Check if Buy one get one product
        if (totalCartItems < cartItemsArray.length) {
          fetchCart();
        } 

      }else {

        fetchCart();
      }

    },
    error: function(err){
      console.log('test 123456')
    }
  });
}

$('.account-drawer-close').on('click',function(e){
  if($('body').hasClass('active-sidebar')){
    $('body').removeClass('active-sidebar');
  }
})

$(".site-header-cart--button").on('click',function(e){
  e.preventDefault();
  $(".drw-Drawers, body").addClass("drw-Drawers-active");
  $(".drw-Drawer").addClass("drw-Drawer-active");
  return false;
});

$(".psh-TopBar_Close, .drw-Drawers_Backdrop").on('click',function(){
  $(".drw-Drawers, body").removeClass("drw-Drawers-active");
  $(".drw-Drawer").removeClass("drw-Drawer-active");
});

  
